export enum ThemeName {
    LIGHT = 'light',
    DARK = 'dark',
}

export interface ITheme {
    link: string;
}

export interface IThemes {
    dark: ITheme;
    light: ITheme;
}

export interface IAssetItem {
    link: string;
    icon: string;
}
